/**
 * Утилита для валидации сложности пароля согласно требованиям ИБ
 * Требования:
 * - Минимум 8 символов
 * - Хотя бы одна цифра
 * - Хотя бы одна заглавная буква
 * - Хотя бы одна строчная буква
 * - Хотя бы один специальный символ
 */

export const validatePasswordComplexity = (password) => {
  const errors = []
  
  // Проверка минимальной длины
  if (!password || password.length < 8) {
    errors.push('Пароль должен содержать минимум 8 символов')
  }
  
  // Проверка наличия цифры
  if (!/\d/.test(password)) {
    errors.push('Пароль должен содержать хотя бы одну цифру')
  }
  
  // Проверка наличия заглавной буквы
  if (!/[A-ZА-ЯЁ]/.test(password)) {
    errors.push('Пароль должен содержать хотя бы одну заглавную букву')
  }
  
  // Проверка наличия строчной буквы
  if (!/[a-zа-яё]/.test(password)) {
    errors.push('Пароль должен содержать хотя бы одну строчную букву')
  }
  
  // Проверка наличия специального символа
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(password)) {
    errors.push('Пароль должен содержать хотя бы один специальный символ (!@#$%^&* и т.д.)')
  }
  
  return {
    isValid: errors.length === 0,
    errors: errors
  }
}

/**
 * Получить текст требований к паролю для отображения пользователю
 */
export const getPasswordRequirements = () => {
  return [
    'Минимум 8 символов',
    'Хотя бы одна цифра (0-9)',
    'Хотя бы одна заглавная буква (A-Z)',
    'Хотя бы одна строчная буква (a-z)',
    'Хотя бы один специальный символ (!@#$%^&* и т.д.)'
  ]
}

